export default __webpack_public_path__ + "static/media/spinner.ceb9e1e1.gif";